<template>
  <a-layout style="background: #F7F8FA;height:100vh;">
    <a-layout-content>
      <div class="loginBg">
        <div class="top">
          <a href="https://www.xinnet.com" target="_blank">
            <img class="logo" src="@/assets/images/logo.png" width="74" height="20">
          </a>
          <a class="link" style="color: rgba(0,0,0,0.85);" href="https://www.xinnet.com/service/cjwt/idc/guanli/1587.html" target="_blank">
            帮助中心
          </a>
        </div>
        <!-- <div class="linear"></div> -->
        <div class="loginCon">
          <div class="left">
            <!-- <img style="width: 100%;" src="@/assets/images/login.png" alt=""> -->
          </div>
          <div class="right">
            
            <div class="form">
              <div class="tit">欢迎登录</div>
              <div class="txt">请使用站点的 FTP 账号，密码登录</div>
              <a-form
                :model="formState"
                name="basic"
                :wrapper-col="{ span: 24 }"
                autocomplete="off"
                @finish="onFinish"
                @finishFailed="onFinishFailed"
              >
                <xn-alert v-if="msgError"  class="s3-mt s5-mb errormsg" type="danger" title="" mode="inline" closeable>
                  <p>用户名或密码错误</p>
                </xn-alert>
                <!-- <xn-alert type="danger" title="用户名或密码错误"></xn-alert> -->
                <a-form-item
                  label=""
                  name="hostName"
                  :rules="[{ required: true, message: '请输入用户名' }]"
                >
                  <a-input style="height: 40px;" placeholder="请输入您的主机用户名" v-model:value="formState.hostName" />
                </a-form-item>

                <a-form-item
                  label=""
                  name="password"
                  :rules="[{ required: true, message: '请输入密码' }]"
                >
                  <a-input-password style="height: 40px;" placeholder="请输入您的主机密码" v-model:value="formState.password" />
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    block
                    type="primary"
                    html-type="submit"
                    :loading="loading"
                    @click="initTencentVerify"
                    class="loginbtn xn-operation"
                    style="box-shadow: none;"
                  >
                    登 录
                  </a-button>
                </a-form-item>
              </a-form>
            </div>
          </div>
        </div>
        <div class="bot">
          <p>Copyright © 1993-2024 北京新网数码信息技术有限公司 版权所有</p>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script lang="ts" setup>
import { reactive, ref } from 'vue'
import { LOGIN } from '@/api/main'
import { useRouter } from 'vue-router'

interface FormState {
  hostName: string
  password: string
}

const router = useRouter()
const loading = ref(false)
const msgError = ref(false)
const formState = reactive<FormState>({
  hostName: '',
  password: ''
})
const onFinish = (values: any) => {
  console.log('Success:', values)
}

const onFinishFailed = (errorInfo: any) => {
  console.log('Failed:', errorInfo)
}

const initTencentVerify = () => {
  try {
    // 生成一个验证码对象
    // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
    //callback：定义的回调函数
    var captcha1 = new TencentCaptcha('2066116126', (res) => {
      // domainYkjExport(getParams())
      // 执行操作，需要传递res.randstr, res.ticket到后台请求接口进行滑块票据验证
      if (res.randstr.length && res.ticket.length) {
        loading.value = true
        let PWD = Xinnet.util.aesEncrypt(formState.password, '_iO7A3WcloTHiVrU')
        const param = new FormData()
        param.append('hostName', formState.hostName)
        param.append('password', PWD)
        param.append('captchaRand', res.randstr)
        param.append('captchaTicket', res.ticket)
        LOGIN(param).then((res:any) => {
          try {
            if(res.code == '403') {
              msgError.value = true
            } else {
              const route = window.location.hash.split('?r=')[1]
              router.push(route)
              msgError.value = false
            }
          } catch (e) { 
            router.push('/')
          }
        }).finally(() => {
          setTimeout(() => {
            loading.value = false
          }, 1000)
        })
      }
    })
    // 调用方法，显示验证码
    captcha1.show()
  } catch (error) {
    // 加载异常，调用验证码js加载错误处理函数
    console.log('生成验证码异常')
  }
}
</script>
<style lang="scss" scoped>
.loginBg {
  .top {
    background: #fff;
    backdrop-filter: blur(24px);
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    align-items: center;
    height: 55px;
  }
  // background: #F7F8FA;
  background-image: url('@/assets/images/bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  // background-attachment: fixed;
  // background-position: 100%;
  min-height: 100vh;
  position: relative;
}

.loginCon {
  
  // padding: 113px 10% 113px 10%;
  display: flex;
  // width: 100%;
  // padding-top: 1%;
  .left {
    // flex: 1;
    width: calc(100vw - 500px);
  }
  .right {
    padding-top: 5%;
    position: relative;
    z-index: 1;
    margin-right: 90px;
    // margin-right: 10%;
    .form {
      margin-top: 25%;
      padding: 45px 44px 0 44px;
      width: 468px;
      // height: 360px;
      background: linear-gradient( 180deg, #FFFFFF 0%, #FFFFFF 100%);
      box-shadow: 0px 2px 40px -12px rgba(108,111,125,0.3), 0px 2px 6px 0px rgba(212,222,233,0.31);
      border-radius: 12px;
      .tit {
        font-weight: 600;
        font-size: 22px;
        margin-bottom: 12px;
        color: rgba(0,0,0,0.85);
        color: rgba(0,0,0,0.85);
      }
      .txt {
        color: rgba(0,0,0,0.65);
        margin-bottom: 24px;
      }
    }
  }
  padding-bottom: 113px;
}
.bot {
  position: absolute;
  bottom: 10px;
  width: 100%;
  p {
    color: rgba(0,0,0,0.45);
    font-size: 12px;
    text-align: center;
  }
}
.form {
  :deep {
    .alert-info .inline {
      padding: 11px 0 11px 19px!important;
    }
    .close-icon{
      top: 16px !important;
    }
  }
}
.loginbtn{
    width: 380px;
    height: 40px;
    margin-bottom: 44px;
}

</style>